// extracted by mini-css-extract-plugin
export default {"mainContainer":"OfflinePayments_mainContainer__7TJ+m","flexContainer":"OfflinePayments_flexContainer__VynKG","field":"OfflinePayments_field__38oTu"};